<template>
    <v-btn  dark
            :icon="$vuetify.breakpoint.smAndDown || isCircular"
            medium
            @click="logOut"
            color="#FD6A3E">
        <v-icon :left="$vuetify.breakpoint.mdAndUp || isCircular" >ub-logout</v-icon>
        <slot v-if="$vuetify.breakpoint.mdAndUp || isCircular "></slot>
    </v-btn>
</template>

<script>
    import {Auth} from 'aws-amplify';
    import AmplifyStore from "@/store/store";
    import router from "@/router/router";

    export default {
        name: "LogOut",
        props:['setCircular'],
        data(){
            return{
            }
        },
        computed:{
            isCircular(){
                return this.setCircular || false
            }
        },
        methods:{
            async logOut(){
                try {
                    await Auth.signOut();
                    this.$store.commit('setUser', null)
                    localStorage.clear();
                    this.$router.push({ path: '/home' });
                } catch (e) {
                    this.$emit('LogOutError', e.message)
                }
            }
        }
    }
</script>

<style scoped>

</style>